import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WebPagesComponent } from './web-pages/web-pages.component';

const routes: Routes = [
  {
    path: 'webPages/about',
    component: WebPagesComponent
  },
  {
    path: 'webPages/privacyPolicy',
    component: WebPagesComponent
  },
  {
    path: 'webPages/termsAndConditions',
    component: WebPagesComponent
  },
  {
    path: 'webPages/cancellationPolicy',
    component: WebPagesComponent
  },
  {
    path: 'webPages/accountDeletion',
    component: WebPagesComponent
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedModulesRoutingModule { }
